import * as config from './config'
import $ from 'jquery'
import * as menu from './menu'
import router from '../router'
import store from '../store'
import * as dict from './dict'

/**
 * 从本地获取菜单资源、字典项
 * @returns {Promise<any>}
 */
export function fetchLocalData () {
  // 强制刷新本地数据缓存
  store.dispatch('setSessionDictMap', dict.dictMap)

  // 从服务器获取菜单
  return new Promise(function (resolve, reject) {
    // 初始化菜单数组[客户端结构]: 整理数据，将json串转为Array，与webf中操作一致：【服务端返回的是菜单的树形结构，按先后顺序排列】
    resolve(initMenus(menu.menuList))
  })
}

/**
 * 从服务器获取菜单资源
 * @returns {Promise<any>}
 */
export function fetchServerData () {
  // 从服务器获取菜单
  return new Promise(function (resolve, reject) {
    // 初始化菜单数组[客户端结构]: 整理数据，将json串转为Array，与webf中操作一致：【服务端返回的是菜单的树形结构，按先后顺序排列】
    resolve(initMenus(store.state.session.menuList))
  })
}

const DEFAULT_PAGE = '/welcome'

/**
 * 菜单类[客户端使用]
 * @param index
 * @param id
 * @param pid -1表示一级节点
 * @param name
 * @param src
 * @param degree 0表示一级节点
 * @param icon
 * @param style
 */
export function Menu (index, id, pid, name, src, degree, icon) {
  this.index = index
  this.id = id
  this.pid = pid
  this.name = name
  this.src = src
  this.degree = degree
  this.icon = icon
}

/**
 * 本地菜单列表
 * @type {Array}
 */
let menus = []

/**
 * 初始化本地菜单列表:Menu对象数组
 * @param menuList
 */
function initMenus (menuList) {
  menus = []
  if (!menuList) {
    menuList = []
  }
  for (let i = 0; i < menuList.length; i++) {
    if (menuList[i].menu_pid === '-1' && (!menuList[i].show || menuList[i].show !== false)) {
      let degree = 0
      menus[menus.length] = new Menu(menus.length, menuList[i].menu_id, menuList[i].menu_pid, menuList[i].menu_name, menuList[i].menu_src == null ? '' : menuList[i].menu_src.trim(), degree, menuList[i].menu_icon)
      recureMenus(menuList, i, menuList[i].menu_id, degree)
    }
  }
  return menus
}

function recureMenus (menuList, index, pid, degree) {
  for (let i = index + 1; i < menuList.length; i++) {
    if (menuList[i].menu_pid === pid && (!menuList[i].show || menuList[i].show !== false)) {
      menus[menus.length] = new Menu(menus.length, menuList[i].menu_id, menuList[i].menu_pid, menuList[i].menu_name, menuList[i].menu_src == null ? '' : menuList[i].menu_src.trim(), degree + 1, menuList[i].menu_icon)
      recureMenus(menuList, i, menuList[i].menu_id, degree + 1)
    }
  }
}

export function fixMenuStyle () {
  let module = store.state.session.module
  if (config.layout === 1 && !module && !module.id) {
    return
  }
  // 获取当前模块下的菜单最大级别
  let degreeMax = 0
  if (config.layout === 1) {
    for (let i = module.index + 1; i < menus.length; i++) {
      degreeMax = (degreeMax < menus[i].degree) ? menus[i].degree : degreeMax
    }
  } else {
    for (let i = 0; i < menus.length; i++) {
      degreeMax = (degreeMax < menus[i].degree) ? menus[i].degree : degreeMax
    }
    degreeMax = degreeMax + 1
  }
  $('.m1,.m2,.m3,.m4,.m5,.m').each(function () {
    let id = $(this).attr('id').substring(5)
    if ($('#mc_' + id).find('div').length > 0) {
      $(this).find('span').addClass('expanded')
    }
  })

  switch (degreeMax) {
    case 1:
      $('.m1').addClass('mfix')
      break
    case 2:
      $('.m1').addClass('m5fix')
      $('.m2').addClass('mfix')
      break
    case 3:
      $('.m1').addClass('m4fix')
      $('.m2').addClass('m5fix')
      $('.m3').addClass('mfix')
      break
    case 4:
      $('.m1').addClass('m3fix')
      $('.m2').addClass('m4fix')
      $('.m3').addClass('m5fix')
      $('.m4').addClass('mfix')
      break
    case 5:
      $('.m1').addClass('m2fix')
      $('.m2').addClass('m3fix')
      $('.m3').addClass('m4fix')
      $('.m4').addClass('m5fix')
      $('.m5').addClass('mfix')
      break
    default:
      break
  }
  // IE7下mc占了一行处理
  $('.mc').not(':has(\'div\')').height(0)
}

export function setModule (ctx, menu) {
  // 隐藏所有浮动菜单区
  $('#mt').hide()
  if (!menu) {
    ctx.$router.push({path: getNewSrc(DEFAULT_PAGE)})
    return
  }
  if (menu.src !== '') {
    ctx.$router.push({path: getNewSrc(menu.src)})
    return
  }
  if (menu.index < menus.length - 1) {
    if (menus[menu.index + 1].pid === menu.id) {
      // 延迟加载，菜单加载有个时延
      let set = null
      let check = function () {
        if (store.state.session.thumb === 1) {
          clearInterval(set)
          set = null
          setMenu(ctx, menus[menu.index + 1])
        } else {
          if ($('#menu_' + menus[menu.index + 1].id).length > 0) {
            clearInterval(set)
            set = null
            setMenu(ctx, menus[menu.index + 1])
          }
        }
      }
      set = setInterval(check, 100)
    }
  } else {
    ctx.$router.push({path: getNewSrc(DEFAULT_PAGE)})
  }
}

export function setMenu (ctx, menu) {
  toggleMenu(menu)
  if (!menu) {
    ctx.$router.push({path: getNewSrc(DEFAULT_PAGE)})
    return
  }
  if (menu.src !== '') {
    ctx.$router.push({path: getNewSrc(menu.src)})
    return
  }
  let degree = menu.degree
  for (let i = menu.index + 1; i < menus.length; i++) {
    if (menus[i].degree <= degree) {
      break
    }
    toggleMenu(menus[i])
    if (menus[i].src !== '') {
      ctx.$router.push({path: getNewSrc(menus[i].src)})
      return
    }
    degree = menus[i].degree
  }
  ctx.$router.push({path: getNewSrc(DEFAULT_PAGE)})
}

export function setThumbMenu (menu) {
  if (!menu) {
    router.push({path: getNewSrc(DEFAULT_PAGE)})
    return
  }
  if (menu.src !== '') {
    router.push({path: getNewSrc(menu.src)})
    return
  }
  let degree = menu.degree
  for (let i = menu.index + 1; i < menus.length; i++) {
    if (menus[i].degree <= degree) {
      break
    }
    if (menus[i].src !== '') {
      router.push({path: getNewSrc(menus[i].src)})
      return
    }
    degree = menus[i].degree
  }
  router.push({path: getNewSrc(DEFAULT_PAGE)})
}

//  收缩下级菜单
function toggleMenu (menu) {
  if (store.state.session.thumb === 1) {
    return
  }
  if ($('#mc_' + menu.id).length === 0) {
    return
  }
  //  找到本菜单的展开状态
  if ($('#mc_' + menu.id).css('display') === 'none') {
    $('#mc_' + menu.id).show(300, function () {
      if ($('#menu_' + menu.id).find('span').hasClass('expanded')) {
        $('#menu_' + menu.id).find('span').removeClass('expanded')
        $('#menu_' + menu.id).find('span').addClass('collapsed')
      } else {
        if ($('#menu_' + menu.id).find('span').hasClass('collapsed')) {
          $('#menu_' + menu.id).find('span').removeClass('collapsed')
          $('#menu_' + menu.id).find('span').addClass('expanded')
        }
      }
    })
  } else {
    $('#mc_' + menu.id).hide(300, function () {
      if ($('#menu_' + menu.id).find('span').hasClass('expanded')) {
        $('#menu_' + menu.id).find('span').removeClass('expanded')
        $('#menu_' + menu.id).find('span').addClass('collapsed')
      } else {
        if ($('#menu_' + menu.id).find('span').hasClass('collapsed')) {
          $('#menu_' + menu.id).find('span').removeClass('collapsed')
          $('#menu_' + menu.id).find('span').addClass('expanded')
        }
      }
    })
  }

  $('.m1,.m2,.m3,.m4,.m5,.m').each(function () {
    if ($(this).hasClass('selected')) {
      // menu_dot缩进处理(因为选中的菜单有3px的边框，此处做处理)
      if ($(this).css('background-position') != null) {
        let p = $(this).css('background-position').split(' ')
        if (p.length > 0 && p[0].indexOf('px') !== -1) {
          $(this).css('background-position', (parseInt(p[0].replace('px', ''), 10) + 3) + 'px center')
        }
      } else {
        // IE8
        let p = $(this).css('background-positionX')
        if (p.indexOf('px') !== -1) {
          $(this).css('background-positionX', (parseInt(p.replace('px', ''), 10) + 3) + 'px center')
        }
      }
      // 文字缩进处理(因为选中的菜单有3px的边框，此处做处理)
      let p = $(this).css('paddingLeft')
      if (p.indexOf('px') !== -1) {
        $(this).css('paddingLeft', (parseInt(p.replace('px', ''), 10) + 3) + 'px')
      }

      $(this).removeClass('selected')
    }
  })

  $('#menu_' + menu.id).addClass('selected')

  // menu_dot缩进处理(因为选中的菜单有3px的边框，此处做处理)
  if ($('#menu_' + menu.id).css('background-position') != null) {
    let p = $('#menu_' + menu.id).css('background-position').split(' ')
    if (p.length > 0 && p[0].indexOf('px') !== -1) {
      $('#menu_' + menu.id).css('background-position', (parseInt(p[0].replace('px', ''), 10) - 3) + 'px center')
    }
  } else {
    // IE8
    let p = $('#menu_' + menu.id).css('background-positionX')
    if (p.indexOf('px') !== -1) {
      $('#menu_' + menu.id).css('background-positionX', (parseInt(p.replace('px', ''), 10) - 3) + 'px')
    }
  }
  // 文字缩进处理(因为选中的菜单有3px的边框，此处做处理)
  let p = $('#menu_' + menu.id).css('paddingLeft')
  if (p.indexOf('px') !== -1) {
    $('#menu_' + menu.id).css('paddingLeft', (parseInt(p.replace('px', ''), 10) - 3) + 'px')
  }
}

export function setLayout () {
  // let p1x = $('#p1').position().left
  if (!$('#p1').position()) {
    // vue logout后此对象不存在导致控制台读取不到相关的top left等属性
    return
  }
  let p1y = $('#p1').position().top
  let p2x = $('#p2').position().left
  // let p2y = $('#p2').position().top
  // let p3x = $('#footer-container').position().left
  let p3y = $('#footer-container').position().top
  // footer-container隐藏修正
  if ($('#footer-container').css('display') === 'none') {
    // p3x = $('#p3').position().left
    p3y = $('#p3').position().top
  }
  let p4x = $('#p4').position().left
  // let p4y = $('#p4').position().top
  if (config.layout === 1) {
    $('#module-container').show()
  } else {
    $('#module-container').hide()
  }
  // 布局图标模式
  if (store.state.session.thumb === 1) {
    $('#menu-container').width(50)
    $('#header-container').css('paddingLeft', '5px')
    $('#module-container-thumb').css({'top': '8px', 'left': '16px', 'fontSize': '16px'})
  } else {
    $('#menu-container').width(200)
    $('#header-container').css('paddingLeft', '10px')
    $('#module-container-thumb').css({'top': '9px', 'left': '20px', 'fontSize': '15px'})
  }
  // 正常状态
  $('#module').width(p2x - p4x - $('#module-left').width() - $('#module-right').width() - 20)
  $('#menu-container').height(p3y - p1y - $('#menu-container').position().top)
  $('#work-container').css('left', $('#menu-container').get(0).offsetWidth)
  $('#work-container').width(p2x - p4x - 1 - $('#menu-container').get(0).offsetWidth)
  $('#work-container').height(p3y - p1y - $('#menu-container').position().top)
  // menu、module-container隐藏
  if ($('#menu-container').css('display') === 'none') {
    if ($('#module-container').css('display') === 'none') {
      $('#work-container').height(p3y - p1y - $('#header-container').height())
    } else {
      $('#work-container').height(p3y - p1y - $('#header-container').height() - $('#module-container').height())
    }
  }
  // 修正菜单样式
  fixMenuStyle()

  // 缩略图菜单平滑展开
  $('#menu-container').off('mouseenter').unbind('mouseleave')
  $('#menu-container').hover(
    function (event) {
      if (store.state.session.thumb === 1) {
        expandMenuTree()
      }
    },
    function (event) {
    }
  )
}

// 显示菜单树
function expandMenuTree () {
  // 往左缩进10px，防止菜单树层出来后又触发hoverout
  $('#mtree').css({top: $('#menu-container').offset().top, left: -10, height: $('#menu-container').height() - 20})
  $('#mtree').show(150)
  $('#mtree').off('mouseenter').unbind('mouseleave')
  $('#mtree').hover(
    function (event) {
    },
    function (event) {
      $('#mtree').hide(150)
    }
  )
}

function getNewSrc (src) {
  hideMenuContainer(src)
  return src
}

function hideMenuContainer (src) {
  var portalPage = '/index'
  if (src == null) {
    return
  }
  if (src.substr(0, portalPage.length) === portalPage) {
    if (config.layout !== 1) {
      // 如果布局不显示模块栏，且当前菜单要隐藏菜单栏，为了防止菜单栏隐藏导致无法切换菜单，此处做特殊处理
      // 一般隐藏菜单栏的菜单是大屏页面，没有下级菜单
      $('#menu-container').show()
      setLayout()
      return
    }
    if ($('#menu-container').css('display') !== 'none') {
      $('#menu-container').hide()
      setLayout()
    }
  } else {
    if ($('#menu-container').css('display') === 'none') {
      $('#menu-container').show()
      setLayout()
    }
  }
}

export function getDate () {
  let days = ['日', '一', '二', '三', '四', '五', '六']
  let now = new Date()
  let year = now.getFullYear()
  let month = now.getMonth() + 1
  let date = now.getDate()
  let day = now.getDay()
  let week = days[day]
  let dt = ''
  dt += year + '年'
  dt += month + '月'
  dt += date + '日 '
  dt += ' 星期' + week
  return dt
}

$(window).resize(function () {
  setLayout()
  // 因为延迟调整不到位，再调整一次
  setTimeout(setLayout(), 500)
})
